import ApiProvider from 'libs/providers/api/api.provider';
import { Observable, of } from 'rxjs';
import countries from '../../../../assets/data/countries.json';
import env from 'libs/constants/env';
import RequestProvider from 'domains/core-base/request/providers/request-provider';
import { AjaxResponse } from 'rxjs/ajax';
import CustomerDto from '../dtos/customer-dto';
import CustomerMapping from '../mappings/customer-mapping';

class CustomerProvider {
  static _provider: ApiProvider = new ApiProvider();

  static queryByTypeAndDocument = (params: {
    documentId: string;
    documentType: string;
    authorization: string;
    recaptcha: string;
  }): Observable<AjaxResponse<CustomerDto>> => {
    return this._provider.post(
      `${env.CONTEXT_PATH}/clientes/buscar`,
      {
        tipoDocumento: params.documentType,
        numeroDocumento: params.documentId
      },
      {
        Authorization: params.authorization,
        'Transaccion-Id': env.DEFAULT_REQUEST_ID,
        'g-recaptcha-response': params.recaptcha,
      },
    );
  };

  static getUbigeos = (params: {
    authorization: string;
  }): Observable<AjaxResponse<any>> => {
    const request = RequestProvider.getInstance();
    return this._provider.get(`${env.CONTEXT_PATH}/ubicaciones/obtener-ubigeos`, {
      Authorization: params.authorization,
      'Transaccion-Id': request.getRequestId(),
    });
  };

  static getCuntries(): Observable<any> {
    return of(countries);
  }

  static update = (params: any): Observable<AjaxResponse<any>> => {
    const request = RequestProvider.getInstance();
    const data = new CustomerMapping().formatPatchCustomerRequest(
      params.customer,
    );
    return this._provider.patch(
      `${env.CONTEXT_PATH}/clientes/${params.customer.id}`,
      {
        ...data,
      },
      {
        Authorization: params.authorization,
        'Transaccion-Id': request.getRequestId(),
        'g-recaptcha-response': params.recaptcha,
      },
    );
  };
}
export default CustomerProvider;
